<template>
  <v-container>
    <v-card
      v-for="(ticketGroup, ticketGroupIndex) in fields.ticketGroups"
      :key="ticketGroup.id"
      class="mb-5"
    >
      <v-container>
        <v-card-title class="d-flex flex-row justify-lg-space-between">
          Группа билетов "{{ ticketGroup.title || ticketGroupIndex + 1 }}"
          <v-btn :disabled="isOnlyEdit" icon @click="deleteTicketGroup(ticketGroup.id, ticketGroupIndex)"
            ><v-icon color="red">mdi-trash-can-outline</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="primary-form__item is-multiple-controls size-1x1x1x">
          <v-row>
            <v-col cols="12">
              <span>Название*</span>
              <v-text-field
                outlined
                v-model="ticketGroup.title"
                placeholder="Группа билетов 1"
                :disabled="loading || isOnlyEdit"
                :loading="loading"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6">
              <span>Цена*</span>
              <v-text-field
                v-model.number="ticketGroup.price"
                outlined
                placeholder="0 ₽"
                :disabled="loading || isOnlyEdit"
                :loading="loading"
              />
            </v-col>
            <v-col cols="6">
              <span>Количество*</span>
              <v-text-field
                outlined
                v-model.number="ticketGroup.quantity"
                type="number"
                placeholder="100"
                :disabled="loading || isOnlyEdit"
                :loading="loading"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span>Зависимость от времени</span>
              <v-switch :disabled="isOnlyEdit" v-model="ticketGroup.scheduleDependant" />
            </v-col>
            <v-col cols="8">
              <template v-if="ticketGroup.scheduleDependant">
                <span v-if="!getEventSchedulesLength">Нет расписаний</span>
                <template v-else-if="eventSchedules">
                  <v-checkbox
                    v-for="schedule in eventSchedules"
                    :key="schedule.id"
                    :disabled="isOnlyEdit"
                    :label="String(schedule.name)"
                    :value="schedule.id"
                    multiple
                    class="mr-1"
                    v-model="ticketGroup.schedules"
                  />
                </template>
              </template>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="4">
              <span>
                Зависимость от мест
                <v-switch :disabled="isOnlyEdit" v-model="ticketGroup.seatingDependant" />
              </span>
            </v-col>
            <v-col cols="8">
              <template v-if="ticketGroup.seatingDependant">
                <span v-if="!!getEventSeatZones">Нет мест</span>
                <template v-else-if="eventSeatZones">
                  <v-checkbox
                    v-for="seatZone in eventSeatZones"
                    :key="seatZone.id"
                    :disabled="isOnlyEdit"
                    :label="seatZone.title"
                    :value="seatZone.id"
                    class="mr-1"
                    multiple
                    v-model="ticketGroup.seatZones"
                  />
                </template>
              </template>
            </v-col>
          </v-row>
        </v-card-text>

        <div v-if="!getEventSchedulesLength && !fields.ticketGroups.length">
          <div>Билетов нет</div>
        </div>
      </v-container>
    </v-card>
    <v-card-actions>
      <v-btn
        secondary
        size-big
        class="primary-form__add-section-btn"
        :disabled="!eventSchedules || isOnlyEdit"
        @click="createTicketGroup"
      >
        Добавить билеты
      </v-btn>
    </v-card-actions>
    <ErrorMessage
      v-if="!eventSchedules"
      :message="'Необходимо хотя бы одно расписание'"
    />
  </v-container>
</template>

<script>
import FormAbstract from '@/components/abstract/form'
import ErrorMessage from '@/components/error-messages'

class TicketGroup {
  title = null
  price = null
  quantity = null
  eventId = null
  scheduleDependant = false
  seatingDependant = false
  schedules = []
  seatZones = []

  constructor (title, price, quantity) {
    this.title = title
    this.price = price
    this.quantity = quantity
  }
}
// const eventSchedulesErrorMsg = 'Необходимо создать минимум 1 билет'
export default {
  extends: FormAbstract,
  name: 'FormEventTickets',
  components: {
    ErrorMessage
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    eventSeatZones: {
      type: Array,
      default: () => []
    },
    eventSchedules: {
      type: Array,
      default: () => []
    },
    isOnlyEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      eventSchedulesErrorMsg: '',
      fields: {
        ticketGroups: []
      }
    }
  },
  computed: {
    getEventSchedulesLength () {
      return this.eventSchedules?.length || null
    },
    getEventSeatZones () {
      return this.eventSeatZones?.length || null
    },
    returnTicket () {
      return this.fields?.ticketGroups
    }
  },
  watch: {
    // eventSchedules () {
    //   this.eventSchedulesErrorMsg = !this.eventSchedules.length ? eventSchedulesErrorMsg : ''
    // },
    data (newVal) {
      this.populate(newVal)
    },
    returnTicket: {
      deep: true,
      handler (newVal) {
        this.$emit('ticket-update', newVal)
      }
    }
  },
  methods: {
    populate (data) {
      if (data.ticketGroups === undefined) {
        return
      }
      // this.fields.ticketGroups = data.ticketGroups
      this.fields.ticketGroups = [...data.ticketGroups].map(ticketGroup => {
        ticketGroup.schedules = ticketGroup.schedules.map(schedule => {
          if (schedule.id !== undefined) {
            return schedule.id
          }
          return schedule
        })
        ticketGroup.seatZones = ticketGroup.seatZones.map(seatZone => {
          if (seatZone.id !== undefined) {
            return seatZone.id
          }
          return seatZone
        })
        return ticketGroup
      })
    },
    createTicketGroup () {
      this.fields.ticketGroups.push(new TicketGroup())
    },
    deleteTicketGroup (id, index) {
      if (id) {
        this.$emit('remove', id)
        this.fields.ticketGroups.splice(index, 1)
      } else {
        this.fields.ticketGroups.splice(index, 1)
      }
    }
  },
  created () {
    if (this.data) {
      this.populate(this.data)
    }
  }
}
</script>
